import api from './api';

export const MISC_SET_ORDERS_TOTAL = 'MISC_SET_ORDERS_TOTAL';

export default function reducer(state = {}, { type, payload }) {
  switch (type) {
    case MISC_SET_ORDERS_TOTAL:
      return {
        ...state,
        ordersTotal: payload,
      };
    default:
      return state;
  }
}

export function setOrdersTotal(total) {
  return { type: MISC_SET_ORDERS_TOTAL, payload: total };
}

export function fetchOrdersTotal() {
  return (dispatch) => {
    dispatch(setOrdersTotal(null));

    return dispatch(api.get('orders/global-total', undefined, { cache: 'default' })).then(
      (ordersTotalResponse) => dispatch(setOrdersTotal(ordersTotalResponse.content.total))
    );
  };
}



// WEBPACK FOOTER //
// ./ducks/misc.js